import { useState } from "react";
import { useSite, UI } from "@/lib/site";
import { MaskLine } from "@/components/Reveal";
import { CaseCard } from "@/components/CaseCard";
import { CaseModal } from "@/components/CaseModal";
import { SocialButtons } from "@/components/WaButton";
import { LogoMark } from "@/components/Logo";

const LG_SPAN = { 0: "lg:col-span-3", 1: "lg:col-span-2", 2: "lg:col-span-1" };
const SM_SPAN = { 0: "sm:col-span-2", 1: "sm:col-span-1" };

export const CasesGrid = ({ items, onOpen }) => {
  const { t } = useSite();
  const n = items.length;
  return (
    <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {items.map((c, i) => <CaseCard key={c.id} item={c} onOpen={onOpen} index={i} />)}
      <div className={`relative flex min-h-[260px] flex-col justify-between overflow-hidden rounded-[22px] border border-[#e6ca7a]/25 bg-[#171310] p-7 ${SM_SPAN[n % 2]} ${LG_SPAN[n % 3]}`} data-testid="cases-cta-tile">
        <LogoMark className="pointer-events-none absolute -bottom-10 -right-10 w-56 opacity-25" />
        <p className="font-display relative text-3xl leading-tight text-[#f6ecd9] md:text-4xl">{t(UI.wantSame)}</p>
        <SocialButtons label={t(UI.discuss)} className="relative mt-6" testPrefix="cases-cta" dark />
      </div>
    </div>
  );
};

export const Cases = () => {
  const { t, content } = useSite();
  const [open, setOpen] = useState(null);
  const all = Array.isArray(content?.cases) ? content.cases : [];
  const featured = all.filter((c) => c.featured).slice(0, 3);
  const rest = all.filter((c) => !featured.includes(c));

  return (
    <section id="cases" data-testid="cases-section" className="relative bg-[#0e0c0a] px-5 pb-24 pt-8 text-[#f6ecd9] md:px-10 md:pb-36">
      <div className="mx-auto max-w-[1400px]">
        <div className="border-t border-[#e6ca7a]/15 pt-20">
          <p className="eyebrow !text-[#e6ca7a]">{t(UI.casesEyebrow)}</p>
          <h2 className="font-display mt-6 max-w-4xl text-4xl font-medium leading-[1.02] sm:text-5xl lg:text-6xl">
            <MaskLine inView>{t(UI.cases)}</MaskLine>
          </h2>
        </div>

        {featured.length > 0 && (
          <div className="mt-14 grid gap-5 lg:grid-cols-12">
            <div className="lg:col-span-7"><CaseCard item={featured[0]} onOpen={setOpen} big frame="aspect-[4/5] sm:aspect-[16/10] lg:aspect-auto lg:h-[720px]" /></div>
            <div className="grid gap-5 lg:col-span-5">
              {featured.slice(1).map((c, i) => <CaseCard key={c.id} item={c} onOpen={setOpen} index={i + 1} frame="aspect-[4/3] lg:aspect-auto lg:h-[350px]" />)}
            </div>
          </div>
        )}

        <h3 className="eyebrow mt-24 !text-[#e6ca7a]">{t(UI.allProjects)} · {all.length}</h3>
        <div className="mt-8"><CasesGrid items={rest} onOpen={setOpen} /></div>
      </div>
      <CaseModal item={open} onClose={() => setOpen(null)} />
    </section>
  );
};
